import { classes, Tab, Tabs } from "@bloomberg/media-ui-core";
import React from "react";
import { Placeholder } from "@bloomberg/media-ui-article";
import styles from "./barCharts.module.css";
import SectionTitle from "~components/SectionTitle";
import PlaceholderImage from "~components/Placeholder";

interface BarChartPlaceholderProps {
  title: string;
}

export const BarChartPlaceholder = ({ title }: BarChartPlaceholderProps) => {
  return (
    <>
      <SectionTitle className={styles.barChartTitle} text={title} />
      <Tabs
        className={classes([styles.barChartTabs, styles.placeholder])}
        size="small"
        variant="basic"
      >
        <Tab title="Quarterly" className={styles.barChartTab}>
          <div className={styles.placeholderContainer}>
            <PlaceholderImage height={158} />
            <Placeholder>
              <Placeholder.Line short />
              <Placeholder.Line />
              <Placeholder.Line />
              <Placeholder.Line />
            </Placeholder>
          </div>
        </Tab>
        <Tab title="Annual" className={styles.barChartTab}>
          <div />
        </Tab>
      </Tabs>
    </>
  );
};
